module.exports = __webpack_public_path__ + "img/wizards-of-the-coast.ca77e49a.svg";